import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { createFeedback } from '../../actions/feedback';
import ReviewForm from '../../components/ReviewForm';

class FeedbackFormContainer extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    createFeedback: PropTypes.func.isRequired,
    displayTitleField: PropTypes.bool,
  };

  static defaultProps = {
    displayTitleField: false,
  };

  state = {
    loading: false,
  };

  handleFormSubmit = (err, values) => {
    this.setState({ loading: true });

    return this.props.createFeedback({
      author: values.username,
      rate: values.rate,
      title: values.title,
      data: values.message,
    })
      .then(() => {
        this.props.onSubmit();
        this.setState({
          loading: false,
        });
      })
      .catch(({ body }) => {
        this.setState({
          loading: false,
        });

        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({
          username: body.author,
          message: body.data,
        });
      });
  };

  render() {
    return (
      <ReviewForm
        displayTitleField={this.props.displayTitleField}
        labels={{
          rate: 'Your rate',
        }}
        loading={this.state.loading}
        onSubmit={this.handleFormSubmit}
      />
    );
  }
}

const mapDispatchToProps = {
  createFeedback,
};

export default connect(null, mapDispatchToProps)(FeedbackFormContainer);
